/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, ElementRef, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';

@Component({
  selector: 'svg-icon',
  template: ``,
  styleUrls: ['./svg-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SvgIconComponent implements OnChanges {
  @Input() src: string;
  @Input() title: string;

  private elementNgProp;

  constructor(private element: ElementRef, private httpClient: HttpClient, private location: Location) {}

  ngOnChanges(changes) {
    if (changes?.src?.firstChange) {
      this.elementNgProp = [...this.element.nativeElement.attributes].find(
        (prop) => prop && prop.name && prop.name.startsWith('_ngcontent')
      );
    }

    if (changes?.src?.currentValue) {
      this.httpClient.get(this.src, { responseType: 'text' }).subscribe((res) => {
        if (this.title) {
          res = res.replace(/<title>.*<\/title>/, this.title);
        }

        // svg linearGradient workaround
        res = res.replace(/url\(.*#/, 'url(' + this.location.path().replace(/'/g, "\\'") + '#');

        if (this.elementNgProp?.name) {
          res = res.replace('<svg ', `<svg ${this.elementNgProp.name} `);
        }

        this.element.nativeElement.innerHTML = res;
      });
    }
  }
}
